"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.magicLog = exports.errorLog = exports.warnLog = exports.infoLog = void 0;
var warnLogsId = [];
var infoLogsId = [];
var magicLogsId = [];
var errorLogsId = [];

var infoLog = function infoLog(string) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var enviroment = process.env.NODE_ENV;

  if (window && enviroment !== 'production' && enviroment !== 'test') {
    var logIsAlreadyPresent = infoLogsId.indexOf(id) > -1 && id;

    if (!logIsAlreadyPresent) {
      warnLogsId.push(id);
      var infoLogCss = 'color:#00A9E0; font-size: 14px; font-weight: bold; padding:5px; padding-left: 0px;';
      console.log("%c ".concat(string), infoLogCss);
    }
  }
};

exports.infoLog = infoLog;

var warnLog = function warnLog(string) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var enviroment = process.env.NODE_ENV;

  if (window && enviroment !== 'production' && enviroment !== 'test') {
    var logIsAlreadyPresent = warnLogsId.indexOf(id) > -1 && id;

    if (!logIsAlreadyPresent) {
      warnLogsId.push(id);
      var warnLogCss = 'color:#ec6738; font-size: 14px; font-weight: bold; padding:5px; padding-left: 0px;';
      console.log("%c ".concat(string), warnLogCss);
    }
  }
};

exports.warnLog = warnLog;

var errorLog = function errorLog(string) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var enviroment = process.env.NODE_ENV;

  if (window && enviroment !== 'production' && enviroment !== 'test') {
    errorLogsId.push("".concat(id).concat(string));
    var errorLogCss = 'color:red; font-size: 18px; font-weight: bold; padding:5px; padding-left: 0px;';
    console.log("%c ".concat(string), errorLogCss);
  }
};

exports.errorLog = errorLog;

var magicLog = function magicLog(string) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var enviroment = process.env.NODE_ENV;
  var logIsAlreadyPresent = magicLogsId.indexOf(id) > -1 && id;

  if (window && enviroment !== 'production' && enviroment !== 'test') {
    if (!logIsAlreadyPresent) {
      var magicLogCss = 'color:#5bc500; font-size: 14px; font-weight: bold; padding:5px; padding-left: 0px;';
      console.log("%c ".concat(string), magicLogCss);
    }
  }
};

exports.magicLog = magicLog;

//# sourceMappingURL=index.js.map